import styles from './table-editable.module.css'

export const generateClassesBodyColumn = (isActive: boolean) => {
  return `${styles.sortby} ${isActive ? styles['sortby-active'] : ''}`
}
